import useAuth from '@components/_hooks/useAuth';
import useUserDiscount from '@components/_hooks/useUserDiscount';
import Box from '@mui/material/Box';
import BoxContainerV2 from '../Reusables/BoxContainerV2'

const HeaderLoggedInBanner = () => {
    
    const {isAuthenticated, isAgent} = useAuth();
    const {hasProductDiscounts} = useUserDiscount();

    if(!isAuthenticated || isAgent()) return false;

    const hasDiscount = hasProductDiscounts();


    const message = hasDiscount ? `Your account has been approved and discounted prices are being displayed` : 'Your account has not yet been approved. Once approved, discounted prices will automatically show';

    return (
        <Box
            sx={{
                backgroundColor: hasDiscount ? 'success.main' : 'error.main',
                color: 'success.contrastText',
                minHeight: '40px',
                top: 0,
                zIndex: 500,
                fontWeight: 400,
            }}
            className="margin-auto text-vertical position-sticky text-center justify-center fs-lg-16 fs-md-16 fs-xs-14 mobile-p-2"
        >
            <BoxContainerV2>
                {message}
            </BoxContainerV2>
        </Box>
    )
}

export default HeaderLoggedInBanner